import { render, staticRenderFns } from "./NewHelpListAjax.vue?vue&type=template&id=77637aaf&"
import script from "./NewHelpListAjax.vue?vue&type=script&lang=js&"
export * from "./NewHelpListAjax.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports